import get from "lodash/get";
import {isFeatureEnabled} from "shared/Utils/FeatureUtils";
import startCase from "lodash/startCase";

/*
 * This function returns the first matching degree based on uni's degree type order
 * along with the degree type when degree feature is enabled
 * @param sender: chat group's sender information
 * @param university
 * @param t: translations function
 * @returns {string}: e.g "Major: Bachelor's in Technology"
 */

export const getMentorInboxInfoOne = ({sender, university, t}) => {
    let mentorDegreeInfo = "";

    if (isFeatureEnabled("enableDegreeTypes", university) && sender?.accountRole === "mentor") {
        const degreeTypesOrder = get(university, "degreeTypeOrder", []);
        for (const degree of degreeTypesOrder) {
            const matchedDegree = get(sender, "degrees", []).find(
                (deg) => deg.degreeType === degree.type,
            );
            if (matchedDegree) {
                const degreeType = matchedDegree.degreeType.toLowerCase();
                mentorDegreeInfo = `${t(`inbox:${degreeType}`, startCase(degreeType))}: ${
                    matchedDegree.degree.name
                }`;
                break;
            }
        }
    }
    return mentorDegreeInfo;
};
